export default __webpack_public_path__ + "static/media/Beard_3_C3.0016e9a4.svg";